function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { __rest } from "tslib";
import QRCode from 'qrcode';
export var LEVELS = ['low', 'medium', 'quartile', 'high', 'L', 'M', 'Q', 'H']; // eslint-disable-next-line @typescript-eslint/no-magic-numbers

export var MASK_PATTERNS = [0, 1, 2, 3, 4, 5, 6, 7];
export var MODES = ['alphanumeric', 'numeric', 'kanji', 'byte'];
export var TYPES = ['image/png', 'image/jpeg', 'image/webp'];
var MAX_QR_VERSION = 40;
export default {
  props: {
    version: {
      type: Number,
      validator: function validator(version) {
        return version === Number.parseInt(String(version), 10) && version >= 1 && version <= MAX_QR_VERSION;
      }
    },
    errorCorrectionLevel: {
      type: String,
      validator: function validator(level) {
        return LEVELS.includes(level);
      }
    },
    maskPattern: {
      type: Number,
      validator: function validator(maskPattern) {
        return MASK_PATTERNS.includes(maskPattern);
      }
    },
    toSJISFunc: Function,
    margin: Number,
    scale: Number,
    width: Number,
    color: {
      type: Object,
      validator: function validator(color) {
        return ['dark', 'light'].every(function (c) {
          return ['string', 'undefined'].includes(_typeof(color[c]));
        });
      }
    },
    type: {
      type: String,
      validator: function validator(type) {
        return TYPES.includes(type);
      }
    },
    quality: {
      type: Number,
      validator: function validator(quality) {
        return quality === Number.parseFloat(String(quality)) && quality >= 0 && quality <= 1;
      }
    },
    value: {
      type: [String, Array],
      required: true,
      validator: function validator(value) {
        if (typeof value === 'string') {
          return true;
        }

        return value.every(function (_ref) {
          var data = _ref.data,
              mode = _ref.mode;
          return typeof data === 'string' && (mode == null || MODES.includes(mode));
        });
      }
    }
  },
  data: function data() {
    return {
      dataUrl: ''
    };
  },
  watch: {
    $props: {
      deep: true,
      immediate: true,
      handler: 'toDataURL'
    }
  },
  methods: {
    toDataURL: function toDataURL() {
      var _this = this;

      var _a = this.$props,
          quality = _a.quality,
          props = __rest(_a, ["quality"]);

      return QRCode.toDataURL(this.value, Object.assign(props, quality == null || {
        renderOptions: {
          quality: quality
        }
      })).then(function (dataUrl) {
        return _this.dataUrl = dataUrl;
      }).catch(function (err) {
        return _this.$emit('error', err);
      });
    }
  },
  render: function render() {
    return this.$createElement('img', {
      domProps: Object.assign(Object.assign({}, this.$attrs), {
        src: this.dataUrl
      })
    });
  }
};